<template>
  <div class="filter">
    <div class="filterContainer">
      <div class="mr10">
        <span class="w120 tar title">国家/省州：</span>
        <a-tree-select
          class="w300"
          v-model:value="filterForm.areaCodes"
          style=""
          :tree-data="areaList"
          allow-clear
          :fieldNames="{
            label: 'nameEn',
            value: 'key'
          }"
          search-placeholder="请选择"
        />
      </div>
      <div class="mr10">
        <span class="w120 tar title">是否启用：</span>
        <a-select
          ref="select"
          v-model:value="filterForm.enable"
          style="width: 220px"
          :allowClear="true"
        >
          <!-- <a-select-option :value="null">全部</a-select-option> -->
          <a-select-option :value="0">禁用</a-select-option>
          <a-select-option :value="1">启用</a-select-option>
        </a-select>
      </div>
      <div class="mr10 mb20 tar" style="width: 160px;">
        <a-button class="mr10" @click="() => resetParams()">重置</a-button>
        <a-button type="primary" @click="handleSearchParams()">查询</a-button>
      </div>
    </div>
    <div class="filterContainer">
      <div style="display: flex;flex-direction: row-reverse;"></div>
    </div>
  </div>
</template>
<script>
import { inject, toRefs, reactive } from 'vue'
import { TreeSelect } from 'ant-design-vue'
export default {
  components: {},
  setup() {
    const state = reactive({
      SHOW_PARENT: TreeSelect.SHOW_PARENT,
      handleSelect: (value, node) => {
        node.dataRef.expand = true
        if (node.dataRef.children) {
          // 如果节点是父节点且没有子节点，则展开该节点
          node.dataRef.expand = true
        }
      }
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.filter {
  background: #ffffff;
}

.filterContainer {
  display: flex;
  flex-direction: row;
}

.filter .title {
  display: inline-block;
}
</style>
